import { SVGProps } from "react"

const StarSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? "17px"}
    height={props.width ?? "17px"}
    fill="none"
    viewBox="0 0 28 28"
  >
    <circle cx={13.164} cy={13.329} r={12.954} fill="#F1FFBB" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M3.413 22.122A13.476 13.476 0 0 1 .21 13.365C.21 5.984 6.073 0 13.303 0c4.513 0 8.493 2.33 10.847 5.877a13.475 13.475 0 0 1 3.202 8.758C27.352 22.016 21.49 28 14.259 28c-4.513 0-8.492-2.33-10.846-5.878Zm9.89 3.081c6.405 0 11.597-5.3 11.597-11.838 0-6.538-5.192-11.838-11.596-11.838-6.405 0-11.597 5.3-11.597 11.838 0 6.538 5.192 11.838 11.596 11.838Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      d="M8.497 21.337c-.29.224-.691-.061-.585-.416l1.74-5.806a.386.386 0 0 0-.14-.423L4.97 11.374c-.296-.216-.146-.692.217-.692H10.8c.165 0 .31-.11.358-.272l1.79-6.09a.372.372 0 0 1 .717 0l1.79 6.09a.375.375 0 0 0 .358.272h5.611c.364 0 .514.476.218.692l-4.543 3.318a.386.386 0 0 0-.14.423l1.74 5.806c.107.355-.295.64-.584.416l-4.582-3.56a.368.368 0 0 0-.453 0l-4.582 3.56Z"
    />
  </svg>
)

export default StarSvg
